"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var moment = require("moment");
var calendar_input_1 = require("../shared/calendar_input");
var bind_1 = require("../../bind");
var MINIMUM_SEND_DATE = moment().add(1, 'day');
var GiftCardSendDatePicker = /** @class */ (function (_super) {
    tslib_1.__extends(GiftCardSendDatePicker, _super);
    function GiftCardSendDatePicker(props) {
        var _this = _super.call(this, props) || this;
        var sendAt = _this.props.sendAt;
        _this.state = {
            sendAt: (sendAt && moment(sendAt)) || null,
            sendNow: !_this.props.sendAt,
        };
        return _this;
    }
    GiftCardSendDatePicker.prototype.onChange = function (sendAt) {
        this.setState({ sendAt: sendAt });
    };
    GiftCardSendDatePicker.prototype.toggleSendNow = function () {
        var sendNow = !this.state.sendNow;
        if (sendNow) {
            this.setState({
                sendNow: sendNow,
                sendAt: null,
            });
        }
        else {
            this.setState({
                sendNow: sendNow,
                sendAt: MINIMUM_SEND_DATE,
            });
        }
    };
    GiftCardSendDatePicker.prototype.formatHiddenSendAt = function () {
        if (this.state.sendAt) {
            return this.state.sendAt.format(calendar_input_1.YEAR_MONTH_DAY_FORMAT);
        }
        return '';
    };
    GiftCardSendDatePicker.prototype.render = function () {
        return (React.createElement("div", { className: "form-group mb-0" },
            React.createElement("div", { className: "form-group__header" },
                React.createElement("label", null, I18n.t('discovery.giftCards.deliveryDate.title'))),
            React.createElement("div", { className: "form-group__fields" },
                React.createElement("div", { className: "label-with-radio" },
                    React.createElement("input", { name: "sendTiming", id: "sendNow", type: "radio", onChange: this.toggleSendNow, checked: this.state.sendNow }),
                    React.createElement("label", { htmlFor: "sendNow" }, I18n.t('discovery.giftCards.deliveryDate.sendNow'))),
                React.createElement("div", { className: "label-with-radio" },
                    React.createElement("input", { name: "sendTiming", id: "sendLater", type: "radio", onChange: this.toggleSendNow, checked: !this.state.sendNow }),
                    React.createElement("label", { htmlFor: "sendLater" }, I18n.t('discovery.giftCards.deliveryDate.chooseDate'))),
                !this.state.sendNow && (React.createElement("div", { className: "width-40 mobile-width-100 mt-half" },
                    React.createElement(calendar_input_1.default, { minDate: MINIMUM_SEND_DATE, currentDate: this.state.sendAt, onChange: this.onChange }))),
                React.createElement("input", { type: "hidden", value: this.formatHiddenSendAt(), name: "gift_card_form[send_at]" }))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], GiftCardSendDatePicker.prototype, "onChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], GiftCardSendDatePicker.prototype, "toggleSendNow", null);
    tslib_1.__decorate([
        bind_1.default
    ], GiftCardSendDatePicker.prototype, "formatHiddenSendAt", null);
    return GiftCardSendDatePicker;
}(React.Component));
exports.default = GiftCardSendDatePicker;
//# sourceMappingURL=gift_card_send_date_picker.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/gift_cards/gift_card_send_date_picker.js
// module id = NT6O
// module chunks = 20 21